'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' });

var Straighten = function Straighten(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Straighten = (0, _pure2.default)(Straighten);
Straighten.muiName = 'SvgIcon';

exports.default = Straighten;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Straighten.js
// module id = 2898
// module chunks = 0